import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  image: {
    width: '100%',
    objectFit: 'cover',
    display: 'block',
  },
}));

export default useStyles;
